import { normalizeMediaUrl, safeDecodeUriComponent } from "./mediaUrl";

// Baixa o arquivo com o nome original. O atributo `download` de um <a> é
// ignorado em URL de outra origem (a API), por isso o arquivo passa por um blob;
// se o fetch falhar, abre a URL direto e o navegador decide.
const downloadMediaFile = async (url, filename = "arquivo") => {
  const normalizedUrl = normalizeMediaUrl(url);
  if (!normalizedUrl) return;

  try {
    const response = await fetch(normalizedUrl, { credentials: "include" });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const blob = await response.blob();
    const objectUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = safeDecodeUriComponent(filename) || "arquivo";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(objectUrl);
  } catch (error) {
    window.location.href = normalizedUrl;
  }
};

export default downloadMediaFile;
